import $ from "jquery";
import { Dropdown } from "bootstrap";
import "jszip";
import "pdfmake";
import "datatables.net-buttons";
import "datatables.net-colreorder";
import "datatables.net-editor";
import "datatables.net-fixedcolumns";
import "datatables.net-fixedheader";
import "datatables.net-responsive";
import "datatables.net-rowgroup";
import "datatables.net-rowreorder";
import "datatables.net-searchpanes";
import "datatables.net-select";
import "datatables.net-staterestore";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import JSZip from "jszip";
(window as any).JSZip = JSZip;
import { InCoreSwal2, InCoreSwal2Icon } from "./swal.utils";
import { InCoreDateTimePickers } from "./flatpickr.utils";
import { InCoreHasPermission, LoadActionsPermissions, GetPermissionCached } from "./permissions.utils";

const DT_AZIONI_SELECTOR = ".dt-azioni";
const DT_AZIONI_ZINDEX = 2000;
const DT_AZIONI_EDGE_PADDING = 8;
// Classe messa sul wrapper delle tabelle con responsive: false (scroll orizzontale con overflow):
// CSS dell'overflow e fix dei dropdown azioni valgono solo per queste tabelle.
const DT_NO_RESPONSIVE_CLASS = "dt-no-responsive";
const DT_AZIONI_NO_RESPONSIVE_SELECTOR = `.${DT_NO_RESPONSIVE_CLASS} ${DT_AZIONI_SELECTOR}`;
let azioniDropdownFixInitialized = false;

//// Extend DataTables types to include 'ext'
declare global {
    namespace DataTables {
        interface Api {
            isDataTable: (table: string | HTMLElement | JQuery) => boolean;
        }
    }
}

// CLASSE PER LA CREAZIONE DELLE AZIONI DI RIGA
type HRefAction = {
    label: string;
    classes: string;
    href: string;
    target: string;
    permissionType: string;
    permissionValue: string;
    conditionField?: string;
    conditionValues?: string;
    disableField?: string;
    disableValues?: string;
    disableTooltip?: string;
};

type OnClickAction = {
    label: string;
    classes: string;
    click: string;
    permissionType: string;
    permissionValue: string;
    conditionField?: string;
    conditionValues?: string;
    disableField?: string;
    disableValues?: string;
    disableTooltip?: string;
};

type Action = HRefAction | OnClickAction;

export class InCoreDTActions {
    private actions: Action[];

    constructor() {
        this.actions = [];
    }

    /**
     * AGGIUNTA DI UNA AZIONE DI RIGA DI TIPO LINK
     * @param label TESTO DA MOSTRARE SUI PULSANTI (COMPATIBILE CON LE ICONE DI FONTAWESOME)
     * @param classes CLASSI CSS DA ASSEGNARE AL PULSANTE
     * @param href INDIRIZZO DEL COLLEGAMENTO DEL PULSANTE
     * @param target INDICA SE APRIRE IN QUESTA FINESTRA (DEFAULT: _self) O IN UNA NUOVA TAB
     * @param permissionType TIPO DI PERMESSO DI VISUALIZZAZIONE DEL PULSANTE
     * @param permissionValue VALORE DI PERMESSO DI VISUALIZZAZIONE DEL PULSANTE
     * @param conditionField CAMPO DELLA RIGA DA CUI DIPENDE LA VISIBILITA' DEL PULSANTE (VUOTO: SEMPRE VISIBILE)
     * @param conditionValues VALORI DEL CAMPO PER I QUALI IL PULSANTE SI VEDE, SEPARATI DA |
     * @param disableField CAMPO DELLA RIGA DA CUI DIPENDE LA DISABILITAZIONE DEL PULSANTE (VUOTO: SEMPRE ABILITATO)
     * @param disableValues VALORI DEL CAMPO PER I QUALI IL PULSANTE E' DISABILITATO, SEPARATI DA |
     * @param disableTooltip TESTO MOSTRATO AL PASSAGGIO DEL MOUSE SUL PULSANTE DISABILITATO
     * @returns L'OGGETTO InCoreDTActions PER POTER CHIAMARE UNA NUOVA EVENTUALE .Add* IN CASCATA
     */
    public AddHRef(label: string, classes: string, href: string, target: string = "_self", permissionType: string, permissionValue: string, conditionField: string = "", conditionValues: string = "", disableField: string = "", disableValues: string = "", disableTooltip: string = ""): this {
        const action: HRefAction = { label, classes, href, target, permissionType, permissionValue, conditionField, conditionValues, disableField, disableValues, disableTooltip };
        this.actions.push(action);
        return this;
    }

    /**
     * AGGIUNTA DI UNA AZIONE DI RIGA DI TIPO ON CLICK
     * @param label TESTO DA MOSTRARE SUI PULSANTI (COMPATIBILE CON LE ICONE DI FONTAWESOME)
     * @param classes CLASSI CSS DA ASSEGNARE AL PULSANTE
     * @param click FUNZIONE (COME TESTO) DA ESEGUIRE AL CLICK SUL PULSANTE
     * @param permissionType TIPO DI PERMESSO DI VISUALIZZAZIONE DEL PULSANTE
     * @param permissionValue VALORE DI PERMESSO DI VISUALIZZAZIONE DEL PULSANTE
     * @param conditionField CAMPO DELLA RIGA DA CUI DIPENDE LA VISIBILITA' DEL PULSANTE (VUOTO: SEMPRE VISIBILE)
     * @param conditionValues VALORI DEL CAMPO PER I QUALI IL PULSANTE SI VEDE, SEPARATI DA |
     * @param disableField CAMPO DELLA RIGA DA CUI DIPENDE LA DISABILITAZIONE DEL PULSANTE (VUOTO: SEMPRE ABILITATO)
     * @param disableValues VALORI DEL CAMPO PER I QUALI IL PULSANTE E' DISABILITATO, SEPARATI DA |
     * @param disableTooltip TESTO MOSTRATO AL PASSAGGIO DEL MOUSE SUL PULSANTE DISABILITATO
     * @returns L'OGGETTO InCoreDTActions PER POTER CHIAMARE UNA NUOVA EVENTUALE .Add* IN CASCATA
     */
    public AddOnClick(label: string, classes: string, click: string, permissionType: string, permissionValue: string, conditionField: string = "", conditionValues: string = "", disableField: string = "", disableValues: string = "", disableTooltip: string = ""): this {
        const action: OnClickAction = { label, classes, click, permissionType, permissionValue, conditionField, conditionValues, disableField, disableValues, disableTooltip };
        this.actions.push(action);
        return this;
    }

    public getActions(): Action[] {
        return this.actions;
    }
}

interface InCoreFilterConfig {
    ColumnName: string;
    Type: string;
    Label?: string;
    Url?: string;
    Values?: Array<{ Key: any; Value: string }> | null;
    Placeholder?: string;
    IsMultiSelect?: boolean;
    DefaultValues?: any[] | null;
    DefaultLabels?: string[] | null;
    ClaimType: string;
    ClaimValue: string;
}

interface InCoreDTConfig {
    filters?: InCoreFilterConfig[];
}

declare function InCoreSelect2(id: string): void;

function InCoreDTCheck(id: string): DataTables.Api | null {
    // Ensure the table exists in the DOM
    const tableElement = $(`#${id}`);
    if (!tableElement.length) {
        console.warn(`Table with ID "${id}" not found.`);
        return null;
    }

    // Check if the table is already initialized
    if ($.fn.dataTable.isDataTable(`#${id}`)) {
        console.warn(`Table with ID "${id}" is already initialized as a DataTable.`);
        return tableElement.DataTable(); // Return the existing DataTable instance
    }

    return null;
}

export async function InCoreDTRenderFilters(
    id: string,
    cfg: InCoreDTConfig,
    table: DataTables.Api | undefined
): Promise<void> {

    if (!table) {
        return;
    }

    const filterContainerId = `filters-${id}`;
    let $container = $(`#${filterContainerId}`);

    if (!$container.length) {
        const $tableEl = $(`#${id}`);
        $container = $(
            `<div id="${filterContainerId}" class="incore-dt-filters incore-row incore-row-7-column"></div>`
        );
        $tableEl.before($container);
    }

    for (const f of (cfg.filters ?? [])) {

        if (f.ClaimType) {
            const hasPermission = await InCoreHasPermission(f.ClaimType, f.ClaimValue ?? "");
            if (!hasPermission) {
                continue;
            }
        }

        const filterId = `${id}_${f.ColumnName}`;

        let isSelect2 = false;
        let isDTP = false;
        let $input: JQuery<HTMLElement>;

        switch (f.Type.toLowerCase()) {
            case 'text':
                $input = $('<input type="text" class="form-control" />')
                    .attr('id', filterId);

                break;

            case 'date':
                $input = $('<input type="text" class="form-control" />')
                    .attr('id', filterId)
                    .attr('data-dtp', '')
                    .attr('data-dateformat', 'Y-m-d')
                    .attr('data-altformat', 'd/m/Y')
                    .attr('placeholder', f.Label ?? f.Placeholder ?? '');

                isDTP = true;

                break;

            case 'select':
                $input = $('<select class="form-select"></select>')
                    .attr('id', filterId)
                    .attr('data-placeholder', f.Placeholder ?? '')
                    .attr('data-allowclear', 'true')
                    .attr('data-nosearch', 'false')
                    .attr('data-pagination', '50');

                if (f.IsMultiSelect) {
                    $input.attr('multiple', 'multiple');
                }


                if (f.Values) {
                    const $nullOption = $('<option></option>');
                    $input.append($nullOption);

                    f.Values?.forEach(({ Key, Value }) => {
                        const $option = $('<option></option>')
                            .attr('value', Key)
                            .text(Value);
                        $input.append($option);
                    });
                }

                isSelect2 = true;

                break;

            case 'select2':
                $input = $('<select class="form-select form-select-sm"></select>')
                    .attr('id', filterId)
                    .attr('data-placeholder', f.Placeholder ?? '')
                    .attr('data-allowclear', 'true')
                    .attr('data-nosearch', 'false')
                    .attr('data-pagination', '50')
                    .attr('data-ajax', f.Url ?? '');

                if (f.IsMultiSelect) {
                    $input.attr('multiple', 'multiple');
                }

                isSelect2 = true;

                break;

            default:
                return;
        }

        const $span = $(`<span class="text-danger" style="display: none;"></div>`);

        let cls = '';
        if (f.Label ?? '' == '') {
            cls = " m-0";
        }

        // Per i filtri date il titolo va come placeholder dentro al box (come i Select2),
        // quindi l'etichetta sopra resta vuota.
        const labelText = isDTP ? '' : (f.Label ?? '');

        const $label = $(`<label class="control-label${cls}"></label>`)
            .text(labelText)
            .attr('for', filterId);

        const labelAbove = isSelect2 || isDTP;

        var classForm = labelAbove ? "w-100 incore-flex" : "form-floating";
        const $form = $(`<div class="${classForm}"></div>`);

        if (labelAbove) {
            $form.append($label).append($input).append($span);
        }
        else {
            $form.append($input).append($label).append($span);
        }

        $container.append($form);

        if (isSelect2) {
            InCoreSelect2(filterId);
        }

        if (isDTP) {
            InCoreDateTimePickers(filterId);

            // Pulsante "x" per svuotare il filtro, come l'allowClear dei Select2.
            $form.addClass('incore-dt-filter-date');
            const $clear = $('<i class="incore-mi-outlined incore-dt-filter-clear" role="button" aria-label="Pulisci">close</i>');
            $form.append($clear);

            const toggleClear = () => {
                const v = $input.val();
                $clear.toggleClass('is-visible', !!(v && v.toString().length > 0));
            };

            $clear.on('click', () => {
                // L'istanza flatpickr può essere stata ricreata (es. auto-init su
                // input[data-dtp]); prendo sempre quella viva dall'elemento.
                const inst = ($input[0] as any)?._flatpickr;
                if (inst && inst.config) {
                    inst.clear();
                } else {
                    $input.val('').trigger('change');
                }
            });

            $input.on('change', toggleClear);
            toggleClear();
        }

        $input.on('change', function () {

            let val = $(this).val();

            const colIdx = table.columns().indexes().toArray()
                .find(i => table.column(i).dataSrc() === f.ColumnName);

            if (colIdx === undefined) return;

            // Filtro data: converto il valore nel formato visualizzato dalla colonna (it-IT)
            if (isDTP) {
                const raw = val ? val.toString() : '';
                const d = raw ? new Date(raw) : null;
                const search = d && !isNaN(d.getTime()) ? d.toLocaleDateString("it-IT") : '';
                table.column(colIdx).search(search).draw();
                return;
            }

            // MULTISELECT
            if (Array.isArray(val) && val.length > 0) {

                const escaped = val.map(v => $.fn.dataTable.util.escapeRegex(String(v)));

                const regex = `^(${escaped.join('|')})$`;

                table
                    .column(colIdx)
                    .search(regex, true, false)
                    .draw();
            }
            // SINGLE SELECT / TEXT
            else if (val) {
                table.column(colIdx)
                    .search(val.toString())
                    .draw();
            }
            // RESET
            else {
                table.column(colIdx)
                    .search('')
                    .draw();
            }
        });

        // Valori preselezionati: applicati dopo aver agganciato l'handler, così il change filtra la colonna.
        const defaults = (f.DefaultValues ?? []).map(String);
        if (isSelect2 && defaults.length > 0) {
            if (f.Type.toLowerCase() === 'select2') {
                // Le opzioni arrivano da ajax: creo quelle di default con il testo fornito.
                defaults.forEach((v, i) => {
                    $input.append(new Option(f.DefaultLabels?.[i] ?? v, v, true, true));
                });
            }
            $input.val(f.IsMultiSelect ? defaults : defaults[0]).trigger('change');
        }
    }
}

/**
 * Initializes a DataTable with custom configuration.
 * @param {string} id - ID of the HTML table.
 * @param {any} delta - Configuration overrides.
 * @param {any} actions - Optional row actions.
 * @param {string} refreshName - Optional refresh button method name.
 * @returns {DataTables.Api | undefined} - DataTable instance or undefined if not found.
 */
export function InCoreDTCustom(id: string, delta: any, actions: any = undefined, refreshName: string | undefined = undefined): DataTables.Api | undefined {

    // Check if the table is already initialized
    var check = InCoreDTCheck(id);
    if (check != null) {
        return check;
    }

    const defaultConfig = {
        //dom: '<"dt-otherButtons-container">f<"dt-buttons-container">B<"dt-filters-block">t<"dt-bottom"lip>',
        layout: {
            top9Start: {
                div: {
                    className: 'dt-title-container'
                }
            },
            top9: null,
            top9End: {
                div: {
                    className: 'dt-otherButtons-container'
                }
            },
            topStart:
            {
                search: {
                    placeholder: 'Cerca',
                },
            },
            top: null,
            topEnd: [
                {
                    div: {
                        className: 'dt-buttons-container'
                    }
                },
                {
                    buttons: [
                        {
                            extend: 'collection',
                            text: '<div>Esporta</div><i class="incore-mi-outlined">arrow_circle_down</i>',
                            buttons: [
                                {
                                    extend: 'excelHtml5',
                                    exportOptions: {
                                        columns: ':visible:not(.dt-actions-column), .dt-export'
                                    }
                                },
                                {
                                    extend: 'csvHtml5',
                                    exportOptions: {
                                        columns: ':visible:not(.dt-actions-column), .dt-export'
                                    }
                                },
                                {
                                    extend: 'copyHtml5',
                                    exportOptions: {
                                        columns: ':visible:not(.dt-actions-column), .dt-export'
                                    }
                                },
                                {
                                    extend: 'print',
                                    exportOptions: {
                                        columns: ':visible:not(.dt-actions-column), .dt-export'
                                    }
                                }
                            ]
                        }
                    ]
                },
            ],
            bottomStart: null,
            bottom: [
                {
                    pageLength: {
                        menu: delta?.lengthMenu ?? [[10, 25, 50, -1], [10, 25, 50, "All"]]
                    }
                },
                'info',
                {
                    paging: {
                        type: 'full_numbers'
                    }
                }
            ],
            bottomEnd: null,
        },
        lengthChange: true,
        searching: true,
        ordering: true,
        info: true,
        autoWidth: false,
        // Di default responsive. Per la tabella con scroll orizzontale passare { responsive: false } nel delta.
        responsive: true,
        language: {
            url: "/lib/datatables/i18n/it-IT.json",
            paginate: {
                first: '<i class="fa-solid fa-angles-left"></i>',
                previous: '<i class="fa-solid fa-chevron-left"></i>',
                next: '<i class="fa-solid fa-chevron-right"></i>',
                last: '<i class="fa-solid fa-angles-right"></i>',
            },
        },
        refreshButton: false
    };

    const config = { ...defaultConfig, ...delta };

    config['initComplete'] = function (): void {
        const wrapperSelector = `#${id}_wrapper`;
        const buttonsContainer = `${wrapperSelector} .dt-buttons-container`;

        // responsive: false -> la tabella scorre in orizzontale (overflow): marco il wrapper e attivo il fix dei dropdown azioni
        if (config.responsive === false) {
            $(wrapperSelector).addClass(DT_NO_RESPONSIVE_CLASS);
            InCoreDTInitAzioniDropdownFix();
        }

        // Move buttons into container
        $(`${wrapperSelector}:not(.dt-buttons-container) > .dt-buttons`).appendTo(buttonsContainer);


        // Add refresh button if defined
        if (refreshName) {

            const fnRefresh = (window as any)[refreshName];
            if (config.refreshButton == true) {
                const refreshButton = $(`
                   <button class="btn btn-empty" style="padding: 0 4px; margin: 5px 1rem 0; color: rgba(55, 116, 255, 1); border-radius: 0;">
                       <i class="incore-mi-normal">refresh</i>
                   </button>
        `       );
                refreshButton.on('click', () => {
                    if (typeof (fnRefresh) === 'function') {
                        fnRefresh();
                    }
                });
                refreshButton.prependTo(buttonsContainer);
            }
        }

        // Move and show other buttons
        $(`.dt-otherButtons[data-dt='${id}']`).appendTo(`${wrapperSelector} .dt-otherButtons-container`).show();

        // Move and show other buttons
        $(`.dt-title[data-dt='${id}']`).appendTo(`${wrapperSelector} .dt-title-container`).show();

        // Move and show subtitle (below the title)
        $(`.dt-subtitle[data-dt='${id}']`).appendTo(`${wrapperSelector} .dt-title-container`).show();

        // Remove sorting class and events
        $('.dt-nosorting').removeClass('sorting').off();

        // Replace label with styled input
        const label = $(`#${id}_filter.dataTables_filter > label`);
        if (label.length) {
            const input = label.find('input[type="search"]').clone(true);
            input.addClass('searchDT').attr('placeholder', 'Cerca');
            label.replaceWith(input);
        }

        // Prevent click propagation on last column if actions are enabled
        if (actions) {
            $(`#${id} tbody`).on('click', 'td:last-child', (e: JQuery.ClickEvent) => {
                e.stopPropagation();
            });
        }

        // Handle double-click and single-click row actions
        $(`#${id} tbody`).on('dblclick', 'tr', function () {
            const link = $(this).find('.dt-doubleclick');
            if (link.length > 0) {
                (link[0] as HTMLElement).click();
            }
        });

        $(`#${id} tbody`).on('click', 'tr', function () {
            const link = $(this).find('.dt-singleclick');
            if (link.length > 0) {
                (link[0] as HTMLElement).click();
            }
        });

        $(`#${id} tbody`).on('click dblclick', '.dt-azioni, .dt-azioni *', function (e) {
            e.stopPropagation();

            // Lo stopPropagation qui sopra (necessario per evitare che i click sulle azioni
            // attivino gli handler di click singolo/doppio della riga) impedisce anche al click
            // di propagarsi fino al document, dove Bootstrap chiude automaticamente i dropdown aperti.
            // Per questo motivo, il dropdown viene chiuso manualmente.
            if (e.type === 'click') {
                const item = (e.target as HTMLElement).closest('.dropdown-item');
                const toggle = item?.closest('.dt-azioni')?.querySelector<HTMLElement>('[data-bs-toggle="dropdown"]');
                if (toggle) Dropdown.getOrCreateInstance(toggle).hide();
            }
        });

    };

    //if (delta.ajax != undefined) {
    //    config['ajax'] = function (): void {

    //    }
    //}

    //config['drawCallback'] = function (): void {

    //}

    if (actions) {
        config.columnDefs = DTManageActions(actions, delta);
    }

    return $(`#${id}`).DataTable(config);
}

/**
 * Initializes a DataTable using configurations fetched from the server.
 * @param {string} id - ID of the HTML table.
 * @param {string} dTName - Name of the DataTable on the server model.
 * @param {string} ajaxUrl - URL for the AJAX call to populate the table.
 * @param {any} actions - Array of actions to add to each row.
 * @param {string} controller - Absolute path for DataTables in other views.
 * @param {any} delta - Configuration overrides.
 * @param {string | undefined} refreshName - Optional refresh button method name.
 * @returns {Promise<DataTables.Api | null>} - DataTable instance or null on failure.
 */
export async function InCoreDTFromModel(
    id: string,
    dTName: string,
    ajaxUrl: string,
    actions: any,
    controller: string = "",
    delta: any = undefined,
    refreshName: string | undefined = undefined
): Promise<DataTables.Api | null | undefined> {
    // Check if the table is already initialized
    var check = InCoreDTCheck(id);
    if (check != null) {
        return check;
    }

    const noaction = !actions || actions.length === 0;
    const cfg = await InCoreReadDTConfig(id, dTName, ajaxUrl, controller, noaction);

    if (!cfg) {
        InCoreSwal2(InCoreSwal2Icon.Error, "Unable to load table configuration");
        return null;
    }

    if (delta) {
        Object.keys(delta).forEach((key) => {
            if (key !== "IdField" && key !== "DTName") {
                cfg[key] = delta[key];
            }
        });
    }

    await LoadActionsPermissions(actions);

    const t = await InCoreDTCustom(id, cfg, actions, refreshName);

    if (cfg.filters && cfg.filters.length > 0) {
        await InCoreDTRenderFilters(id, cfg, t);
    }

    return t;
}

/**
 * Reads DataTable configuration from the server.
 * @param {string} id - ID of the HTML table.
 * @param {string} dTName - Name of the DataTable on the server model.
 * @param {string} ajaxUrl - URL for the AJAX call to populate the table.
 * @param {string} controller - Absolute path for DataTables in other views.
 * @param {boolean} noaction - Whether to exclude the actions column.
 * @returns {Promise<any>} - DataTable configuration object.
 */
export async function InCoreReadDTConfig(
    id: string,
    dTName: string,
    ajaxUrl: string,
    controller: string,
    noaction: boolean
): Promise<any> {
    return new Promise((resolve, reject) => {
        var actionsupposed = false;
        $.ajax({
            type: "GET",
            url: `${controller}InCoreDTConfig/${dTName}`,
            dataType: "json",
            success: (result) => {
               
                const head = $(`#${id} thead tr`);
                result.columns.forEach((col: any) => {
                    const cls = col.exportIfHidden
                        ? 'dt-export'
                        : '';
                    $(head).append(`<th class="${cls}">${col.title}</th>`);
                });

                formatColumns(result.columns);

                if (result.Actions) {
                    $(head).find("th").last().addClass("dt-actions-column dt-nosorting").css("width", "1rem");
                    actionsupposed = true;
                }

                const config = {
                    //dom: new InCoreDTOptions().GetDOM(),
                    ajax: {
                        type: "GET",
                        dataSrc: "",
                        url: ajaxUrl,
                    },
                    columns: result.columns,
                    IdField: result.IdField,
                    actionsGrouped: result.ActionGrouped,
                    order: result.order || [],
                    DTName: dTName,
                    filters: result.filters || []
                };

                if (actionsupposed && noaction) {
                    config.columns.pop();
                }

                resolve(config);
            },
            error: () => {
                InCoreSwal2(InCoreSwal2Icon.Error, "Unable to load table configuration");
                reject(null);
            },
        });
    });
}

// Il render delle azioni gira per ogni riga: senza questo elenco lo stesso errore di
// configurazione riempirebbe la console con una riga per record.
const conditionWarnings = new Set<string>();

/**
 * Indica se il campo della riga vale uno dei valori ammessi (separati da |, maiuscole ignorate).
 * Un campo assente o un elenco vuoto non corrispondono mai e vengono segnalati una sola volta.
 */
function DTRowMatches(row: any, field: string, values: string, dtName: string, label: string, metodo: string, effetto: string): boolean {
    const ammessi = String(values ?? "")
        .split("|")
        .map((v: string) => v.trim().toLowerCase())
        .filter((v: string) => v !== "");

    // Senza segnalazione un errore di configurazione sembra voluto.
    const campoAssente = !(field in (row ?? {}));

    if (campoAssente || ammessi.length === 0) {

        const chiave = `${dtName}|${metodo}|${field}|${label}`;

        if (!conditionWarnings.has(chiave)) {
            conditionWarnings.add(chiave);

            const motivo = campoAssente
                ? `il campo "${field}" non esiste nella riga`
                : `non è stato indicato nessun valore per il campo "${field}"`;

            console.warn(`InCore DataTable "${dtName}": ${metodo} sull'azione "${label}" ${motivo}, quindi l'azione ${effetto}.`);
        }
    }

    const valoreRiga = String(row?.[field] ?? "").trim().toLowerCase();

    return ammessi.includes(valoreRiga);
}

/**
 * Manages row actions for DataTables.
 * @param {any} actions - Actions configuration.
 * @param {any} delta - Additional configuration.
 * @returns {Array} - Column definitions for actions.
 */
export function DTManageActions(actions: any, delta: any): any[] {
    const buttonBlockTop = `
        <div class="dt-azioni dropdown">
            <button class="btn dropdown-toggle" type="button" id="btn_{1}_{0}" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="incore-mi-normal">arrow_drop_down_circle</i>
            </button>
            <ul class="dropdown-menu" aria-labelledby="btn_{1}_{0}">
    `;

    const buttonBlockTopNoAction = `
        <div class="dt-azioni dropdown incore-disabled">
            <button class="btn dropdown-toggle" type="button" id="btn_{1}_{0}" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="incore-mi-normal" style="color:red;">block</i>
            </button>
            <ul class="dropdown-menu" aria-labelledby="btn_{1}_{0}">
    `;

    const buttonHRefBlock = `<li incore-permission-type="{PERMTYPE}" incore-permission-value="{PERMVALUE}">
                                <a class="dropdown-item {CLASSES}" href="{HREF}" target="{TARGET}">{LABEL}</a>
                             </li>`;
    const buttonClickBlock = `<li incore-permission-type="{PERMTYPE}" incore-permission-value="{PERMVALUE}">
                                    <a class="dropdown-item {CLASSES}" onclick="{CLICK}">{LABEL}</a>
                              </li>`;
    const buttonDisabledBlock = `<li incore-permission-type="{PERMTYPE}" incore-permission-value="{PERMVALUE}" title="{TOOLTIP}">
                                    <a class="dropdown-item disabled {CLASSES}" aria-disabled="true">{LABEL}</a>
                                 </li>`;
    const buttonBlockBottom = `</ul></div>`;

    // Action Buttons

    let buttonTop = "<div class='incore-flex-center'>";

    let buttonHRef = '<a class="btn btn-empty p-0 {CLASSES}" href="{HREF}" target="{TARGET}">{LABEL}</a>';

    let buttonClick = '<a class="btn btn-empty p-0 {CLASSES}" onclick="{CLICK}">{LABEL}</a>';

    let buttonDisabled = '<span class="d-inline-block" title="{TOOLTIP}"><a class="btn btn-empty p-0 disabled {CLASSES}" aria-disabled="true">{LABEL}</a></span>';

    let buttonBottom = '</div>';
    return [
        {
            targets: -1,
            data: null,
            class: "text-start",
            render: function (data: any, type: any, row: any) {
                let visibleActions = 0;

                let block = delta.actionsGrouped
                    ? buttonBlockTop
                    : buttonTop;

                actions.getActions().forEach((act: any) => {

                    if (act.permissionType || act.permissionValue) {

                        const allowed = GetPermissionCached(
                            act.permissionType ?? "",
                            act.permissionValue ?? ""
                        );

                        if (!allowed) {
                            return;
                        }
                    }

                    if (act.conditionField
                        && !DTRowMatches(row, act.conditionField, act.conditionValues, delta.DTName ?? "", act.label, "DTShowIf", "resta sempre nascosta")) {
                        return;
                    }

                    const disabled = !!act.disableField
                        && DTRowMatches(row, act.disableField, act.disableValues, delta.DTName ?? "", act.label, "DTDisableIf", "resta sempre abilitata");

                    visibleActions++;

                    if (disabled) {
                        block += (delta.actionsGrouped ? buttonDisabledBlock : buttonDisabled)
                            .replace("{TOOLTIP}", act.disableTooltip ?? "")
                            .replace("{LABEL}", act.label)
                            .replace("{CLASSES}", act.classes)
                            .replace("{PERMTYPE}", act.permissionType ?? "")
                            .replace("{PERMVALUE}", act.permissionValue ?? "");

                    } else if (delta.actionsGrouped) {

                        if (act.href) {
                            block += buttonHRefBlock
                                .replace("{HREF}", act.href)
                                .replace("{TARGET}", act.target)
                                .replace("{LABEL}", act.label)
                                .replace("{CLASSES}", act.classes)
                                .replace("{PERMTYPE}", act.permissionType ?? "")
                                .replace("{PERMVALUE}", act.permissionValue ?? "");
                        }
                        else if (act.click) {
                            block += buttonClickBlock
                                .replace("{CLICK}", act.click)
                                .replace("{LABEL}", act.label)
                                .replace("{CLASSES}", act.classes)
                                .replace("{PERMTYPE}", act.permissionType ?? "")
                                .replace("{PERMVALUE}", act.permissionValue ?? "");
                        }

                    } else {

                        if (act.href) {
                            block += buttonHRef
                                .replace("{HREF}", act.href)
                                .replace("{TARGET}", act.target)
                                .replace("{LABEL}", act.label)
                                .replace("{CLASSES}", act.classes)
                                .replace("{PERMTYPE}", act.permissionType ?? "")
                                .replace("{PERMVALUE}", act.permissionValue ?? "");
                        }
                        else if (act.click) {
                            block += buttonClick
                                .replace("{CLICK}", act.click)
                                .replace("{LABEL}", act.label)
                                .replace("{CLASSES}", act.classes)
                                .replace("{PERMTYPE}", act.permissionType ?? "")
                                .replace("{PERMVALUE}", act.permissionValue ?? "");
                        }
                    }
                });

                if (visibleActions === 0) {
                    block = buttonBlockTopNoAction;
                }

                block += delta.actionsGrouped
                    ? buttonBlockBottom
                    : buttonBottom;

                const idToken = String(row[delta.IdField] ?? "");
                const nameToken = String(delta.DTName ?? "");

                return block
                    .replace(/\{0\}/g, idToken)
                    .replace(/\{1\}/g, nameToken);

            }
        },
    ];
}

/**
 * Loads DataTable configurations from a JSON file and initializes tables.
 * @param {string} path - Path to the JSON file containing table configurations.
 */
export function loadDataTablesFromJSON(path: string): void {
    $.getJSON(path, (data) => {
        $.each(data, (_key, val) => {
            $.each(val, (_k, v) => {
                InCoreDTCustom(v["ID"], { ajax: v["ajax"], columns: v["columns"] });
            });
        });
    });
}

/**
 * Applies formatting to DataTable columns based on their `format` property.
 * @param {any[]} columns - Array of column definitions.
 */
export function formatColumns(columns: any[]): void {
    const toBool = (v: any): boolean => {
        if (v === true) return true;
        if (v === false || v === null || v === undefined) return false;
        if (typeof v === "string") {
            const s = v.trim().toLowerCase();
            if (s === "true" || s === "1" || s === "yes") return true;
            if (s === "false" || s === "0" || s === "no") return false;
            return false;
        }
        if (typeof v === "number") return v === 1;
        return false;
    };

    columns.forEach((col) => {
        switch (col.format) {
            case "integer":
                col.render = (data: any) =>
                    data === null || data === undefined || data === "" ? "" :
                        new Intl.NumberFormat("it-IT", { maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(data);
                break;

            case "number":
                col.render = (data: any) =>
                    data === null || data === undefined || data === "" ? "" :
                        new Intl.NumberFormat("it-IT", { maximumFractionDigits: 2, minimumFractionDigits: 0 }).format(data);
                break;

            case "percentual":
                col.render = (data: any) =>
                    data === null || data === undefined || data === "" ? "" :
                        new Intl.NumberFormat("it-IT", { maximumFractionDigits: 2, minimumFractionDigits: 0 }).format(data) + '%';
                break;
            case "scientific":
                col.render = (data: any) =>
                    data === null || data === undefined || data === "" ? "" :
                        new Intl.NumberFormat("it-IT", { notation: 'scientific' }).format(data);
                break;

            case "engineering":
                col.render = (data: any) =>
                    data === null || data === undefined || data === "" ? "" :
                        new Intl.NumberFormat("it-IT", { notation: 'engineering' }).format(data);
                break;

            case "currency":
                col.render = (data: any) =>
                    data === null || data === undefined || data === "" ? "" :
                        new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(data);
                break;

            case "dot":
                col.render = (data: any) => {
                    if (!data) return "";
                    let prefix: string = '#';
                    if (data.startsWith(prefix)) {
                        prefix = '';
                    }
                    return `<i class="fa-solid fa-circle" style="color: ${prefix}${data}"></i>`;
                };
                break;

            case "textdot":
                col.render = (data: any) => {
                    if (!data) return "";
                    const datas = data.split('|');
                    let prefix = '#';
                    if (datas[0].startsWith(prefix)) {
                        prefix = '';
                    }
                    return `<i class="fa-solid fa-circle" style="color: ${prefix}${datas[0]}"></i>&nbsp;${datas[1]}`;
                };
                break;

            case "date":
                col.render = (data: any, type: any) => {
                    if (!data) return "";
                    const temp = new Date(data);
                    if (isNaN(temp.getTime())) return "";
                    if (type === "sort") {
                        return temp.getTime();
                    }
                    return temp.toLocaleDateString("it-IT");
                };
                break;

            case "datetimeminutes":
                col.render = (data: any, type: any) => {
                    if (!data) return "";
                    const temp = new Date(data);
                    if (isNaN(temp.getTime())) return "";
                    if (type === "sort") {
                        return temp.getTime();
                    }
                    return `${temp.toLocaleDateString("it-IT")} ${temp.toLocaleTimeString("it-IT", {
                        hour: "2-digit",
                        minute: "2-digit",
                    })}`;
                };
                break;

            case "datetimeseconds":
                col.render = (data: any, type: any) => {
                    if (!data) return "";
                    const temp = new Date(data);
                    if (isNaN(temp.getTime())) return "";
                    if (type === "sort") {
                        return temp.getTime();
                    }
                    return `${temp.toLocaleDateString("it-IT")} ${temp.toLocaleTimeString("it-IT", {
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                    })}`;
                };
                break;

            case "boolean":
                col.render = (data: any) => (data === true ? '<i class="fa-solid fa-check"></i>' : "");
                break;

            case "booleanx":
                col.render = (data: any) =>
                    data === true ? '<i class="fa-solid fa-check"></i>' : '<i class="fa-solid fa-xmark"></i>';
                break;

            default:
                break;
        }
    });
}

/**
 * Class for managing DataTable DOM configurations.
 */
export class InCoreDTOptions {
    length: boolean;
    export: boolean;
    search: boolean;
    info: boolean;
    paging: boolean;
    processing: boolean;
    buttons: boolean;
    colreorder: boolean;
    scroller: boolean;
    searchpanes: boolean;
    searchbuilder: boolean;
    table: boolean;

    constructor(
        Length = true,
        Export = true,
        Search = true,
        Info = true,
        Paging = true,
        Processing = true,
        Buttons = true,
        ColReorder = false,
        Scroller = false,
        SearchPanes = false,
        SearchBuilder = false,
        Table = true
    ) {
        this.length = Length;
        this.export = Export;
        this.search = Search;
        this.info = Info;
        this.paging = Paging;
        this.processing = Processing;
        this.buttons = Buttons;
        this.colreorder = ColReorder;
        this.scroller = Scroller;
        this.searchpanes = SearchPanes;
        this.searchbuilder = SearchBuilder;
        this.table = Table;
    }
}

/**
 * Initializes a DataTable with a custom DOM configuration and optional overrides.
 * @param {string} id - ID of the HTML table.
 * @param {string | undefined} dom - Custom DOM configuration. Defaults to the standard DOM.
 * @param {any} delta - Configuration overrides.
 * @param {string | undefined} refreshName - Optional refresh button method name.
 * @returns {DataTables.Api | null} - DataTable instance or null if already initialized.
 */
export async function InCoreDT(
    id: string,
    dom: string | undefined,
    delta: any = undefined,
    refreshName: string | undefined = undefined
): Promise<DataTables.Api | null | undefined> {
    // Check if the table is already initialized
    var check = InCoreDTCheck(id);
    if (check != null) {
        return check;
    }

    // Prepare the configuration
    const deltaInt = {
        //dom: dom ?? new InCoreDTOptions().GetDOM(),
    };

    console.warn(deltaInt);

    if (delta) {
        Object.assign(deltaInt, delta);
    }

    // Initialize the DataTable
    return InCoreDTCustom(id, deltaInt, undefined, refreshName);
}


// ====================================================================
// FIX POSIZIONAMENTO DROPDOWN AZIONI DATATABLE
// Le colonne azioni (.dt-azioni) vivono dentro contenitori con
// overflow-x: auto (scroll orizzontale della tabella), quindi il menu
// verrebbe tagliato dall'overflow del genitore. Alla apertura lo
// "stacchiamo" e lo riposizioniamo in position: fixed, dentro la
// modale se presente (altrimenti nel body), per restare sopra sia
// l'overflow della tabella sia il backdrop della modale.
// ====================================================================
function InCoreDTInitAzioniDropdownFix() {
    // Chiamata da ogni tabella con responsive: false: registro gli handler (delegati sul document) una sola volta
    if (azioniDropdownFixInitialized) return;
    azioniDropdownFixInitialized = true;

    // Funzione helper per chiudere tutti i dropdown azioni aperti
    function closeOpenAzioniDropdowns() {
        $(`${DT_AZIONI_NO_RESPONSIVE_SELECTOR} [data-bs-toggle="dropdown"].show`).each(function () {
            Dropdown.getOrCreateInstance(this).hide();
        });
    }

    // Gestore apertura dropdown: stacca il menu e lo posiziona in fixed
    $(document).on("shown.bs.dropdown", DT_AZIONI_NO_RESPONSIVE_SELECTOR, function (e: JQuery.TriggeredEvent) {
        const toggleEl = e.target as HTMLElement;
        const $toggle = $(toggleEl);
        const $menu = $toggle.parent().find(".dropdown-menu").first();
        if (!$menu.length) return;

        const $modal = $toggle.closest(".modal");
        const $host = $modal.length ? $modal : $("body");

        $menu.data("origin", $toggle.parent());
        $toggle.data("movedMenu", $menu);

        $menu.appendTo($host).css({
            position: "fixed",
            margin: 0,
            transform: "none",
            inset: "auto",
            zIndex: DT_AZIONI_ZINDEX
        });

        const rect = toggleEl.getBoundingClientRect();
        const menuWidth = $menu.outerWidth() ?? 0;
        const menuHeight = $menu.outerHeight() ?? 0;

        let left = $menu.hasClass("dropdown-menu-end") ? rect.right - menuWidth : rect.left;
        left = Math.max(DT_AZIONI_EDGE_PADDING, Math.min(left, window.innerWidth - menuWidth - DT_AZIONI_EDGE_PADDING));

        let top = rect.bottom;
        if (top + menuHeight > window.innerHeight - DT_AZIONI_EDGE_PADDING && rect.top - menuHeight > DT_AZIONI_EDGE_PADDING) {
            top = rect.top - menuHeight;
        }

        $menu.css({ top, left });
    });

    // Gestore chiusura: rimette il menu nel suo origin
    $(document).on("hide.bs.dropdown", DT_AZIONI_NO_RESPONSIVE_SELECTOR, function (e: JQuery.TriggeredEvent) {
        const toggleEl = e.target as HTMLElement;
        const $menu = $(toggleEl).data("movedMenu") as JQuery | undefined;
        if (!$menu) return;

        const $origin = $menu.data("origin") as JQuery;
        $origin.append($menu.removeAttr("style"));
        $(toggleEl).removeData("movedMenu");
    });

    // Se la tabella o la modale scorrono, chiudo i dropdown aperti per non
    // lasciare il menu "sospeso" fuori posizione.
    $(document).on("scroll", `${DT_AZIONI_NO_RESPONSIVE_SELECTOR}, .modal, .${DT_NO_RESPONSIVE_CLASS}`, function () {
        closeOpenAzioniDropdowns();
    });

    // Se la finestra viene ridimensionata o il device ruota, chiudo i dropdown
    // perché la posizione calcolata (fixed) non sarebbe più corretta.
    $(window).on("resize orientationchange", function () {
        closeOpenAzioniDropdowns();
    });
}
